var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header",style:({backgroundColor:_vm.bgColor})},[_c('van-nav-bar',{attrs:{"title":_vm.title,"left-arrow":_vm.leftArrow,"border":false},on:{"click-left":_vm.back}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }